import { IsOptional, IsArray, ValidateNested } from "class-validator";
import { Type } from "class-transformer";

import { IQuery } from "./query.interface";
import { QueryAttributeSortDto } from "./query-attribute-sort.dto";
import { QuerySimpleDto } from "./query-simple.dto";
import { QueryAttributeGroupDto } from "./query-attribute-group.dto";

export class QueryDto extends QuerySimpleDto implements IQuery {
  //
  @IsOptional()
  @ValidateNested()
  @Type(() => QueryAttributeGroupDto)
  query?: QueryAttributeGroupDto;

  @IsOptional()
  @IsArray()
  group_by?: string[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => QueryAttributeSortDto)
  sort?: QueryAttributeSortDto[];

  @IsOptional()
  // It looks like this decorator is causing wrong conversion of incoming arrays.
  // Instead of an array of objects, the server side gets an array of arrays
  @IsArray()
  @Type(() => Object)
  $pipeline?: any[];
}
